// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/course_section_occurrence.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_timeofday } from "@buf/googleapis_googleapis.bufbuild_es/google/type/timeofday_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/course_section_occurrence.proto.
 */
export const file_studyo_today_planners_v1_resources_course_section_occurrence = /*@__PURE__*/
  fileDesc("CkJzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2NvdXJzZV9zZWN0aW9uX29jY3VycmVuY2UucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMiiAIKF0NvdXJzZVNlY3Rpb25PY2N1cnJlbmNlEhkKEWNvdXJzZV9zZWN0aW9uX2lkGAEgASgJEioKCnN0YXJ0X3RpbWUYAiABKAsyFi5nb29nbGUudHlwZS5UaW1lT2ZEYXkSKAoIZW5kX3RpbWUYAyABKAsyFi5nb29nbGUudHlwZS5UaW1lT2ZEYXkSFAoMcGVyaW9kX2xhYmVsGAQgASgJEhgKEGFic29sdXRlX29yZGluYWwYBSABKAUSDwoHb3JkaW5hbBgGIAEoBRIUCgx0ZXJtX29yZGluYWwYByABKAUSEQoJcm9vbV9uYW1lGAggASgJEhIKCmlzX3NraXBwZWQYCSABKAhCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_type_timeofday]);

/**
 * Describes the message studyo.today.planners.v1.resources.CourseSectionOccurrence.
 * Use `create(CourseSectionOccurrenceSchema)` to create a new message.
 */
export const CourseSectionOccurrenceSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_course_section_occurrence, 0);

